import { formatBytes } from '@/lib/utils'

type DownloadProgressProps = {
  message: string
  progress: number
  speed?: number
  eta?: number
}

export const DownloadProgress = ({ message, progress, speed, eta }: DownloadProgressProps) => {
  return (
    <div className="space-y-2 p-3 bg-muted rounded-md">
      <div className="flex items-center justify-between text-sm">
        <span>{message}</span>
        <span className="font-semibold">{progress}%</span>
      </div>
      <div className="w-full h-2 bg-muted-foreground/20 rounded-full overflow-hidden">
        <div className="h-full bg-primary transition-all duration-300" style={{ width: `${progress}%` }} />
      </div>
      {speed != null && eta != null && (
        <div className="flex items-center justify-between text-xs text-muted-foreground">
          <span>{formatBytes(speed)}/s</span>
          <span>残り {Math.ceil(eta)}秒</span>
        </div>
      )}
    </div>
  )
}
